import Script from 'next/script'
import CookieConsent from '../CookieConsent/CookieConsent'

export default function GoogleTagManager({}) {
    if (process.env.NEXT_PUBLIC_ENVIRONMENT !== 'prod') return null
    return (
        <>
            <Script id="google-tag-consent" strategy="afterInteractive">
                {`// Define dataLayer and the gtag function.
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('set', 'url_passthrough', true);

                // Set default consent to 'denied' as a placeholder
                // Determine actual values based on your own requirements
                gtag('consent', 'default', {
                    'ad_personalization': 'denied',
                    'ad_storage': 'denied',
                    'ad_user_data': 'denied',
                    'analytics_storage': 'denied',
                    'functionality_storage': 'denied',
                    'personalization_storage': 'denied', 
                    'security_storage': 'granted' 
                });`}
            </Script>
            <Script id="google-tag-manager" strategy="afterInteractive">
                {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                    'https://analytics.taxd.co.uk/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                    })(window,document,'script','dataLayer','GTM-T5T69K4');`}
            </Script>
            <Script id="ruler-tag" strategy="afterInteractive">
                {`var __raconfig = __raconfig || {};
                    __raconfig.uid = "67079b453a657";
                    __raconfig.action = "track";
                    (function () {
                      var ra = document.createElement("script");
                      ra.type = "text/javascript";
                      ra.src = "https://ruler.nyltx.com/lib/1.0/ra-bootstrap.min.js";
                      var s = document.getElementsByTagName("script")[0];
                      s.parentNode.insertBefore(ra, s);
                    }());`}
            </Script>
            <noscript>
                <iframe
                    src="https://analytics.taxd.co.uk/ns.html?id=GTM-T5T69K4"
                    height="0"
                    width="0"
                    style={{ display: 'none', visibility: 'hidden' }}
                ></iframe>
            </noscript>
            <CookieConsent />
        </>
    )
}
